import { useFormContext, useWatch } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { roundNumberToFixed } from "@/lib/money.util";
import { QuotationUpdateBoFormData } from "@/types/forms/bo/expeditionBo.form";

export const FedexApiInsuranceNotice = () => {
  const { t } = useTranslation("boExpeditionForm");
  const methods = useFormContext<QuotationUpdateBoFormData>();

  const deliveryContent = useWatch({
    control: methods.control,
    name: "deliveryContent",
  });

  const expeditionPackaging = useWatch({
    control: methods.control,
    name: "expeditionFedexApi.expeditionPackaging",
  });

  const totalInsurance = roundNumberToFixed(
    deliveryContent?.reduce(
      (acc: number, item) => acc + Number(item.unitPrice || 0) * Number(item.numberOfBottles || 0),
      0,
    ),
    2,
  );

  const totalValue = roundNumberToFixed(
    expeditionPackaging?.reduce(
      (acc: number, item) => acc + Number(item.value || 0) * Number(item.count || 0),
      0,
    ),
    2,
  );

  if (Math.abs(totalInsurance - totalValue) > 1) {
    return (
      <div className="rounded-md border border-amber-300 bg-amber-50 px-3 py-2 text-center text-sm text-amber-800">
        {t("fedexInsuranceNotice.mismatch")}
      </div>
    );
  }

  return null;
};
